// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    
    

    /*
    render function
    */
    import { desSearchFilterCellRenderFunction } from 'js/desSearchFilterCellService';
    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desSearchFilterCellService', () => import('js/desSearchFilterCellService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "actions": {
        "render": {
            "method": "desSearchFilterCellRenderFunction",
            "deps": "js/desSearchFilterCellService"
        }
    },
    "data": {},
    "conditions": {},
    "onEvent": [],
    "lifecycleHooks": {
        "render": "render"
    },
    "props": {
        "buckets": {
            "type": "object"
        },
        "vmo": {
            "type": "object"
        }
    },
    "messages": {},
    "i18n": {
        "showMore": [
            "searchMessages"
        ],
        "showLess": [
            "searchMessages"
        ]
    },
    "_viewModelId": "DesSearchFilterCell",
    "_uniqueViewModelId": "DesSearchFilterCell",
    "ctx": {}
};

    


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, desSearchFilterCellRenderFunction, undefined, ctxImportObj );

    export default Component;